import { gql } from 'apollo-angular';

export var login = gql`
  mutation Login($authorization_code: String!) {
    createSsoToken(authorization_code: $authorization_code) {
      id
      token
      expiration
      user {
        username
      }
    }
  }
`;
